/**
 * Extracted request-flow chrome styles.
 * Keeps the fixed-header CSS string out of the main editor component so layout code stays readable.
 */
const fixedHeaderStyles = `
    .dbq-fixed-header {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      z-index: 1000;
      background: rgba(0, 0, 0, 0.95);
      border-bottom: none;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
    }

    .dbq-fixed-header-inner {
      max-width: 100%;
      margin: 0 auto;
      padding: 0.5rem 2rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 1.5rem;
    }

    .dbq-fixed-header-logo {
      flex-shrink: 0;
    }

    .dbq-fixed-header-logo img {
      height: 50px;
      width: auto;
    }

    .dbq-fixed-header-title {
      display: flex;
      align-items: center;
      gap: 1rem;
      flex: 1;
      min-width: 0;
    }

    .dbq-fixed-header-title h1 {
      font-size: 1rem;
      font-weight: 500;
      margin: 0;
      color: #ffffff;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      letter-spacing: -0.01em;
    }

    .dbq-header-autosave {
      display: flex;
      align-items: center;
      gap: 0.4rem;
      font-size: 0.75rem;
      color: rgba(255, 255, 255, 0.6);
      white-space: nowrap;
    }

    .dbq-header-autosave-dot {
      width: 6px;
      height: 6px;
      background: #22c55e;
      border-radius: 50%;
      animation: pulse 2s ease-in-out infinite;
    }

    @keyframes pulse {
      0%, 100% { opacity: 0.4; }
      50% { opacity: 1; }
    }

    .dbq-fixed-header-actions {
      display: flex;
      gap: 0.625rem;
      align-items: center;
      flex-shrink: 0;
    }

    .dbq-header-review-switch {
      display: inline-flex;
      align-items: center;
      gap: 0.2rem;
      padding: 0.2rem;
      border-radius: 999px;
      background: rgba(255, 255, 255, 0.1);
      border: 1px solid rgba(255, 255, 255, 0.18);
      box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08);
    }

    .dbq-header-review-switch button {
      border: 0;
      background: transparent;
      color: rgba(255, 255, 255, 0.72);
      border-radius: 999px;
      padding: 0.4rem 0.75rem;
      font-size: 0.8125rem;
      font-weight: 500;
      line-height: 1;
      white-space: nowrap;
      transition: background 0.15s ease, color 0.15s ease, box-shadow 0.15s ease;
    }

    .dbq-header-review-switch button:hover {
      color: #ffffff;
    }

    .dbq-header-review-switch button.is-active {
      background: #ffffff;
      color: #111827;
      box-shadow: 0 8px 18px rgba(0, 0, 0, 0.24);
    }

    .dbq-header-dismissed-btn {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      border: 1px solid rgba(255, 255, 255, 0.18);
      background: rgba(255, 255, 255, 0.08);
      color: rgba(255, 255, 255, 0.82);
      border-radius: 999px;
      padding: 0.42rem 0.72rem;
      font-size: 0.8125rem;
      font-weight: 500;
      line-height: 1;
      white-space: nowrap;
      transition: background 0.15s ease, color 0.15s ease, border-color 0.15s ease;
    }

    .dbq-header-dismissed-btn:hover {
      background: rgba(255, 255, 255, 0.14);
      border-color: rgba(255, 255, 255, 0.28);
      color: #ffffff;
    }

    .dbq-header-btn {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: 0.5rem;
      padding: 0.5rem 1.25rem;
      border-radius: 6px;
      font-weight: 500;
      font-size: 0.8125rem;
      border: none;
      cursor: pointer;
      transition: all 0.15s ease;
      white-space: nowrap;
    }

    .dbq-header-btn-chat {
      background: rgba(255, 255, 255, 0.12);
      color: #ffffff;
      border: 1px solid rgba(255, 255, 255, 0.2);
    }

    .dbq-header-btn-chat:hover:not(:disabled) {
      background: rgba(255, 255, 255, 0.2);
    }

    .dbq-header-btn-save {
      background: #3881cf;
      color: white;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    }

    .dbq-header-btn-save:hover:not(:disabled) {
      background: #4a94dc;
      box-shadow: 0 3px 8px rgba(0, 0, 0, 0.25);
      transform: translateY(-1px);
    }

    .dbq-header-btn-save:active:not(:disabled) {
      transform: translateY(0);
    }

    .dbq-header-btn-send {
      background: #22c55e;
      color: white;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    }

    .dbq-header-btn-send:hover:not(:disabled) {
      background: #2dd36f;
      box-shadow: 0 3px 8px rgba(0, 0, 0, 0.25);
      transform: translateY(-1px);
    }

    .dbq-header-btn-send:active:not(:disabled) {
      transform: translateY(0);
    }

    .dbq-header-btn-sign {
      background: #1a5f9c;
      color: white;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    }

    .dbq-header-btn-sign:hover:not(:disabled) {
      background: #2570b0;
      box-shadow: 0 3px 8px rgba(0, 0, 0, 0.25);
      transform: translateY(-1px);
    }

    .dbq-header-btn-sign:active:not(:disabled) {
      transform: translateY(0);
    }

    .dbq-header-btn-pdf {
      background: #dc2626;
      color: white;
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    }

    .dbq-header-btn-pdf:hover:not(:disabled) {
      background: #ef4444;
      box-shadow: 0 3px 8px rgba(0, 0, 0, 0.25);
      transform: translateY(-1px);
    }

    .dbq-header-btn-pdf:active:not(:disabled) {
      transform: translateY(0);
    }

    .dbq-header-btn:disabled {
      opacity: 0.6;
      cursor: not-allowed;
      transform: none !important;
    }

    .dbq-header-success {
      display: flex;
      align-items: center;
      gap: 0.375rem;
      padding: 0.375rem 0.75rem;
      background: rgba(34, 197, 94, 0.2);
      border: 1px solid rgba(34, 197, 94, 0.4);
      border-radius: 6px;
      color: #22c55e;
      font-size: 0.75rem;
      font-weight: 500;
      animation: successFade 2.5s ease-out forwards;
    }

    @keyframes successFade {
      0% { opacity: 0; transform: scale(0.95); }
      10% { opacity: 1; transform: scale(1); }
      80% { opacity: 1; }
      100% { opacity: 0; }
    }

    .dbq-inline-suggestion-navigator {
      position: fixed;
      top: 74px;
      right: 1.25rem;
      z-index: 990;
      display: inline-flex;
      align-items: center;
      gap: 0.42rem;
      padding: 0.35rem 0.4rem 0.35rem 0.78rem;
      border: 1px solid rgba(15, 23, 42, 0.12);
      border-radius: 999px;
      background: rgba(15, 23, 42, 0.9);
      color: #ffffff;
      box-shadow: 0 16px 42px rgba(15, 23, 42, 0.22);
      backdrop-filter: blur(16px);
      animation: suggestionNavigatorIn 0.18s ease-out;
    }

    @keyframes suggestionNavigatorIn {
      from { opacity: 0; transform: translateY(-4px); }
      to { opacity: 1; transform: translateY(0); }
    }

    .dbq-inline-suggestion-navigator-copy {
      display: inline-flex;
      align-items: baseline;
      gap: 0.48rem;
      min-width: 0;
    }

    .dbq-inline-suggestion-navigator-label {
      color: rgba(255, 255, 255, 0.68);
      font-size: 0.7rem;
      font-weight: 500;
      line-height: 1;
      white-space: nowrap;
    }

    .dbq-inline-suggestion-navigator-current {
      display: inline-flex;
      align-items: baseline;
      gap: 0.18rem;
      max-width: 13rem;
      border: 0;
      background: transparent;
      color: #ffffff;
      padding: 0;
      font-size: 0.8125rem;
      font-weight: 500;
      line-height: 1;
      white-space: nowrap;
    }

    .dbq-inline-suggestion-navigator-current:hover:not(:disabled) {
      color: #bfdbfe;
    }

    .dbq-inline-suggestion-navigator-current:disabled {
      color: rgba(255, 255, 255, 0.52);
    }

    .dbq-inline-suggestion-navigator-loading {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      min-width: 2.4rem;
      color: rgba(255, 255, 255, 0.86);
    }

    .dbq-inline-suggestion-navigator-actions {
      display: inline-flex;
      align-items: center;
      gap: 0.18rem;
      padding-left: 0.18rem;
    }

    .dbq-inline-suggestion-navigator-btn {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 1.72rem;
      height: 1.72rem;
      border: 1px solid rgba(255, 255, 255, 0.12);
      border-radius: 999px;
      background: rgba(255, 255, 255, 0.08);
      color: rgba(255, 255, 255, 0.86);
      transition: background 0.15s ease, color 0.15s ease, transform 0.15s ease;
    }

    .dbq-inline-suggestion-navigator-btn:hover:not(:disabled) {
      background: rgba(255, 255, 255, 0.16);
      color: #ffffff;
      transform: translateY(-1px);
    }

    .dbq-inline-suggestion-navigator-btn:disabled {
      opacity: 0.38;
      cursor: not-allowed;
    }

    /* Spacer to push content below fixed header */
    .dbq-header-spacer {
      height: 66px;
    }

    /* Signed/finalized + stale sticky stack: pinned just below the fixed
       header (66px / 56px responsive), under the review sidebar (1000) and
       MO panel (900) so slide-outs cover it, above the form content. */
    .dbq-post-sign-banner {
      position: sticky;
      top: 66px;
      z-index: 890;
    }

    /* Responsive adjustments */
    @media (max-width: 768px) {
      .dbq-fixed-header-inner {
        padding: 0.5rem 1rem;
        gap: 1rem;
      }

      .dbq-fixed-header-actions {
        min-width: 0;
        overflow-x: auto;
        scrollbar-width: none;
        flex-shrink: 1;
      }

      .dbq-fixed-header-actions::-webkit-scrollbar {
        display: none;
      }
      
      .dbq-fixed-header-logo img {
        height: 40px;
      }
      
      .dbq-fixed-header-title h1 {
        font-size: 0.875rem;
        max-width: 180px;
      }

      .dbq-header-autosave {
        display: none;
      }

      .dbq-header-review-switch button {
        padding: 0.35rem 0.55rem;
        font-size: 0.75rem;
      }

      .dbq-header-dismissed-btn {
        padding: 0.38rem 0.55rem;
        font-size: 0.75rem;
      }

      .dbq-inline-suggestion-navigator {
        top: 64px;
        right: 0.75rem;
        max-width: calc(100vw - 1.5rem);
      }

      .dbq-inline-suggestion-navigator-label {
        display: none;
      }
      
      .dbq-header-btn {
        padding: 0.5rem 0.875rem;
        font-size: 0.75rem;
      }

      .dbq-header-btn span {
        display: none;
      }

      .dbq-header-spacer {
        height: 56px;
      }

      .dbq-post-sign-banner {
        top: 56px;
      }
    }

    @media (max-width: 480px) {
      .dbq-fixed-header-title h1 {
        max-width: 120px;
      }
      
      .dbq-fixed-header-logo img {
        height: 35px;
      }
`

export default fixedHeaderStyles;
